import React from 'react';

import useStoreReferralAttributes from './useStoreReferralAttributes';

const withStoreReferralAttributes = WrappedComponent => {
  return props => {
    const { accountReferralCreate } = useStoreReferralAttributes();

    return (
      <WrappedComponent
        accountReferralCreate={accountReferralCreate}
        {...props}
      />
    );
  };
};

export default withStoreReferralAttributes;
